import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
const privacyContent = <>
    <h3 className="text-2xl font-heading font-bold text-white uppercase mb-6" data-id="element-40">
      Política de Privacidad
    </h3>
    <div className="space-y-4 text-slate-300 text-sm leading-relaxed" data-id="element-41">
      <p data-id="element-42">
        <strong className="text-white" data-id="element-43">Última actualización:</strong> Marzo 2026
      </p>

      <h4 className="text-lg font-semibold text-white mt-6" data-id="element-44">
        1. Información que Recopilamos
      </h4>
      <p data-id="element-45">
        Recopilamos únicamente la información necesaria para procesar tu compra:
        nombre, dirección de correo electrónico y datos de pago. No almacenamos
        información de tarjetas de crédito en nuestros servidores.
      </p>

      <h4 className="text-lg font-semibold text-white mt-6" data-id="element-46">
        2. Uso de la Información
      </h4>
      <p data-id="element-47">Tu información se utiliza exclusivamente para:</p>
      <ul className="list-disc pl-6 space-y-1" data-id="element-48">
        <li data-id="element-49">Procesar y entregar tu compra digital.</li>
        <li data-id="element-50">Enviar actualizaciones relacionadas con la guía.</li>
        <li data-id="element-51">Brindarte soporte técnico si lo necesitas.</li>
      </ul>

      <h4 className="text-lg font-semibold text-white mt-6" data-id="element-52">
        3. Protección de Datos
      </h4>
      <p data-id="element-53">
        Implementamos medidas de seguridad estándar de la industria para
        proteger tu información personal. Utilizamos cifrado SSL para todas las
        transacciones.
      </p>

      <h4 className="text-lg font-semibold text-white mt-6" data-id="element-54">4. Terceros</h4>
      <p data-id="element-55">
        No vendemos, intercambiamos ni transferimos tu información personal a
        terceros, excepto a proveedores de servicios de pago necesarios para
        completar tu transacción.
      </p>

      <h4 className="text-lg font-semibold text-white mt-6" data-id="element-56">5. Cookies</h4>
      <p data-id="element-57">
        Utilizamos cookies esenciales para el funcionamiento del sitio y cookies
        analíticas para mejorar tu experiencia de navegación.
      </p>

      <h4 className="text-lg font-semibold text-white mt-6" data-id="element-58">6. Tus Derechos</h4>
      <p data-id="element-59">
        Puedes solicitar la eliminación de tus datos personales en cualquier
        momento. También puedes optar por no recibir comunicaciones de
        marketing.
      </p>
    </div>
  </>;
const termsContent = <>
    <h3 className="text-2xl font-heading font-bold text-white uppercase mb-6" data-id="element-60">
      Términos y Condiciones
    </h3>
    <div className="space-y-4 text-slate-300 text-sm leading-relaxed" data-id="element-61">
      <p data-id="element-62">
        <strong className="text-white" data-id="element-63">Última actualización:</strong> Marzo 2026
      </p>

      <h4 className="text-lg font-semibold text-white mt-6" data-id="element-64">
        1. Producto Digital
      </h4>
      <p data-id="element-65">
        "Mundial 2026: La Consola de Mando" es un producto digital en formato
        PDF. Al completar tu compra, recibirás acceso inmediato para descargar
        el archivo.
      </p>

      <h4 className="text-lg font-semibold text-white mt-6" data-id="element-66">
        2. Licencia de Uso
      </h4>
      <p data-id="element-67">
        Al adquirir la guía, obtienes una licencia personal e intransferible.
        Queda prohibida la reproducción, distribución o reventa del contenido
        sin autorización expresa.
      </p>

      <h4 className="text-lg font-semibold text-white mt-6" data-id="element-68">
        3. Actualizaciones
      </h4>
      <p data-id="element-69">
        Tu compra incluye acceso vitalicio a todas las actualizaciones de la
        guía hasta el inicio del torneo. Las actualizaciones se enviarán al
        correo electrónico proporcionado durante la compra.
      </p>

      <h4 className="text-lg font-semibold text-white mt-6" data-id="element-70">
        4. Política de Reembolso
      </h4>
      <p data-id="element-71">
        Debido a la naturaleza digital del producto, todas las ventas son
        finales. Si experimentas problemas técnicos con la descarga, nuestro
        equipo te asistirá para resolver cualquier inconveniente.
      </p>

      <h4 className="text-lg font-semibold text-white mt-6" data-id="element-72">
        5. Limitación de Responsabilidad
      </h4>
      <p data-id="element-73">
        La guía proporciona información y recomendaciones basadas en
        investigación. No nos hacemos responsables por cambios en políticas
        migratorias, cancelaciones de vuelos, cambios de precios u otros
        factores externos fuera de nuestro control.
      </p>

      <h4 className="text-lg font-semibold text-white mt-6" data-id="element-74">
        6. Propiedad Intelectual
      </h4>
      <p data-id="element-75">
        Todo el contenido de la guía, incluyendo textos, gráficos, mapas y
        diseños, es propiedad exclusiva de sus creadores y está protegido por
        las leyes de derechos de autor.
      </p>

      <h4 className="text-lg font-semibold text-white mt-6" data-id="element-76">
        7. Disclaimer FIFA
      </h4>
      <p data-id="element-77">
        Este producto no está afiliado, patrocinado ni respaldado por FIFA.
        Todas las marcas registradas pertenecen a sus respectivos propietarios.
        "Mundial 2026" se utiliza únicamente con fines descriptivos.
      </p>
    </div>
  </>;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="mt-24 text-center border-t border-navy-800 pt-8 pb-4" data-id="element-78">
        <p className="text-slate-500 text-sm" data-id="element-79">
          &copy; {new Date().getFullYear()} Mundial 2026: La Consola de Mando.
          Todos los derechos reservados.
        </p>
        <div className="flex items-center justify-center gap-4 mt-3" data-id="element-80">
          <button onClick={() => setActiveModal('privacy')} className="text-slate-500 text-xs underline underline-offset-2 hover:text-gold-400 transition-colors" data-id="element-81">
            Política de Privacidad
          </button>
          <span className="text-slate-700 text-xs" data-id="element-82">|</span>
          <button onClick={() => setActiveModal('terms')} className="text-slate-500 text-xs underline underline-offset-2 hover:text-gold-400 transition-colors" data-id="element-83">
            Términos y Condiciones
          </button>
        </div>
        <p className="text-slate-600 text-xs mt-3 max-w-2xl mx-auto px-4" data-id="element-84">
          Este sitio no está afiliado ni respaldado por FIFA. "Mundial 2026" se
          utiliza únicamente con fines descriptivos.
        </p>
      </footer>

      {/* Modal Overlay */}
      <AnimatePresence data-id="element-85">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-86">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3,
          ease: 'easeOut'
        }} onClick={e => e.stopPropagation()} className="relative w-full max-w-2xl max-h-[80vh] bg-navy-900 border border-navy-700 rounded-2xl shadow-2xl overflow-hidden" data-id="element-87">
              {/* Close button */}
              <button onClick={() => setActiveModal(null)} className="absolute top-4 right-4 z-10 w-10 h-10 flex items-center justify-center rounded-full bg-navy-800 border border-navy-700 text-slate-400 hover:text-white hover:border-gold-500/50 transition-colors" data-id="element-88">
                <XIcon className="w-5 h-5" data-id="element-89" />
              </button>

              {/* Scrollable content */}
              <div className="p-8 pt-6 overflow-y-auto max-h-[80vh]" data-id="element-90">
                {activeModal === 'privacy' ? privacyContent : termsContent}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}